import type { FC } from 'react';
import { useGetAgentArtifactQuery } from '@gonfalon/observability-graphql/hooks';
import { ArtifactChip } from '@gonfalon/observability-ui/components/Artifact';

import { derivePullRequestStateLabel, isPullRequestArtifactType } from './parseArtifactIdentity';

interface Props {
  projectKey: string;
  projectId: string;
  type: string;
  externalId: string;
}

// Wraps ArtifactChip with a lazy DB fetch for inline tokens that weren't pre-resolved
// in the surrounding ArtifactLookupProvider. Loading and error states render the same
// placeholder chip so layout stays stable; on success the chip hydrates with title,
// status, and url. For PRs, prefer live github_pull_request state when present.
export const ArtifactChipLazy: FC<Props> = ({ projectKey, projectId, type, externalId }) => {
  const { data, loading, error } = useGetAgentArtifactQuery({
    variables: { project_id: projectId, type, external_id: externalId },
  });

  const detail = !loading && !error ? data?.agentArtifact : null;
  const artifact = detail?.artifact ?? null;
  const pr = detail?.github_pull_request ?? null;

  const title = pr?.title ?? artifact?.title;
  const url = pr?.html_url ?? artifact?.url;
  const status = pr && isPullRequestArtifactType(type) ? derivePullRequestStateLabel(pr) : (artifact?.status ?? null);

  return (
    <ArtifactChip
      projectKey={projectKey}
      type={type}
      externalId={externalId}
      title={title}
      status={status}
      url={url}
      variant="inline"
      placeholder={!artifact && !pr}
    />
  );
};
